export default {
    UAM_FIRMWARE_TIMEOUT: 180, //firmware timeout
    UAM_UPDATE_SETTING_TIMEOUT: 60, //update settings timeout
    UAM_CHECK_STATUS_INTERVAL: 2, //check request status and connection status each defined seconds if not connected to WebSocket
    UAM_DATA_COLLECTION_TIMEOUT: 180, //data collection timeout
    UAM_DATA_COLLECTION_WAIT_FOR_CANCEL_TIMEOUT: 20, //timeout to data collection to be cancelled on dm side. Any uam flow could not be started
    UAM_DATA_COLLECTION_AFTER_CANCEL_TIMEOUT: 5, //timeout to set data collection in progress "false" after successful response from cancel data collection method. DM is canceled after successful "cancel" response but CM waiting for mw response.
    UAM_DATA_COLLECTION_BEFORE_START_TIMEOUT: 10, // wait time after no user action before data collection start
    UAM_WS_RECONNECT_TIMEOUT: 5, //reconnect timeout to WS after connection error
    UAM_WS_PING_INTERVAL: 500, //ws ping interval
    UAM_AUTO_CLEAN_TIMEOUT: 50, //auto clean timeout
    UAM_SYNC_TIMEOUT: 60, //sync timeout
    UAM_WAIT_FETCH_TOKEN_TIMEOUT: 10, //wait for token response
};
